import { render, staticRenderFns } from "./age-state.vue?vue&type=template&id=94ff2640"
import script from "./age-state.ts?vue&type=script&lang=js&external"
export * from "./age-state.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports